import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=3b40aa5d&"
import script from "./productlist.vue?vue&type=script&lang=ts&"
export * from "./productlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b40aa5d')) {
      api.createRecord('3b40aa5d', component.options)
    } else {
      api.reload('3b40aa5d', component.options)
    }
    module.hot.accept("./productlist.vue?vue&type=template&id=3b40aa5d&", function () {
      api.rerender('3b40aa5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/productlist.vue"
export default component.exports